import { Component, Input, forwardRef } from '@angular/core';
import type { ControlValueAccessor} from '@angular/forms';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

/**
 * Text input that implements ControlValueAccessor so it works with both template and reactive forms.
 */
@Component({
  selector: 'es-input',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InputComponent),
    multi: true,
  }],
  template: `
    <input
      [type]="type"
      [placeholder]="placeholder"
      [disabled]="isDisabled"
      [value]="value"
      [class]="'w-full px-3 py-2 text-sm rounded-lg bg-[var(--bg-secondary)] text-[var(--text)] border border-[var(--border)] placeholder:text-[var(--text-secondary)] focus:outline-none focus:border-echo-blue focus:ring-1 focus:ring-echo-blue/30 transition-colors font-exo disabled:opacity-50'"
      (input)="onInput($event)"
      (blur)="onTouched()"
    />
  `,
})
export class InputComponent implements ControlValueAccessor {
  @Input() type = 'text';
  @Input() placeholder = '';

  value = '';
  isDisabled = false;
  onChange: (value: string) => void = () => {
    // noop — replaced by registerOnChange/registerOnTouched
  };
  onTouched: () => void = () => {
    // noop — replaced by registerOnChange/registerOnTouched
  };

  writeValue(value: string): void { this.value = value ?? ''; }
  registerOnChange(fn: (value: string) => void): void { this.onChange = fn; }
  registerOnTouched(fn: () => void): void { this.onTouched = fn; }
  setDisabledState(disabled: boolean): void { this.isDisabled = disabled; }

  onInput(event: Event): void {
    const val = (event.target as HTMLInputElement).value;
    this.value = val;
    this.onChange(val);
  }
}
